<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <form id="UpdateSubCategory" @submit.prevent="UpdateSubCategory" >
        <CCardHeader>
            <CCol col="6" style="font-size: 25px;">تعديل القسم الفرعي</CCol>
        </CCardHeader>
        <CCardBody>
          <CRow>
              <CCol sm='12'>
                <div class='form-group'>
                    <label for='categories'>
                      القسم الرئيسي
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedCategory'
                        id='categories'
                        :options='categories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر القسم الرئيسي  '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <div v-if(errors.category_id) class="invalid-feedback">
                        {{errors.category_id}}
                      </div>
                    </div>
                  </div>
              </CCol>
            </CRow>
          <CRow>
            <CCol sm="6">
              <CInput label="English Name"
                id="name"
                v-model="subCategory.name"
                class="required"
                placeholder=" أدخل إسم التصنيف بالانجليزية"
                :invalidFeedback="errors.name"
                required
              />
            </CCol>
            <CCol sm="6">
              <CInput label="الإسم"
                id="name_ar"
                v-model="subCategory.name_ar"
                class="required"
                placeholder="أدخل إسم القسم الفرعي بالعربي"
                :invalidFeedback="errors.name_ar"
                required
              />
            </CCol>
          </CRow>
          <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى  بالإنجليزية'
                  horizontal
                  rows='4'
                  v-model='subCategory.description'
                  :invalidFeedback="errors.description"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى بالعربي'
                  horizontal
                  rows='4'
                  v-model='subCategory.description_ar'
                  :invalidFeedback="errors.description_ar"
                />
              </CCol>
            </CRow>
            </CCardBody>
            <CCardFooter>
            <CButton @click="validation()" type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="button" size="sm" color="warning" @click="goBack"><CIcon name="cil-ban"/> رجوع </CButton>
          </CCardFooter>
          </form>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import $ from 'jquery'
import swal from 'sweetalert'
export default {
  name: 'EditSubCategory',
  data () {
    return {
      subCategory: [],
      categories: [],
      selectedCategory: '',
      errors: []
    }
  },
  created () {
    const categories = []
    this.$http
      .get(`${this.$hostUrl}categories`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          categories.push({ id: value.id, name: value.name })
        })
        this.categories = categories
      })
    this.$http
      .get(`${this.$hostUrl}sub-categories/${this.$route.params.id}/edit`)
      .then((response) => {
        this.subCategory = response.data.data.subCategory
        this.selectedCategory = {
          id: this.subCategory.category.id,
          name: this.subCategory.category.name
        }
      })
  },
  methods: {
    async UpdateSubCategory () {
      const formData = new FormData()
      if (this.selectedCategory) {
        formData.append('category_id', this.selectedCategory.id)
      } else {
        this.errors.push('category_id')
        this.errors.category_id = 'category field is required'
        $('.multiselect__tags').addClass('redborder')
        swal('يرجى تحديد الفئة الرئيسية')
        return 0
      }
      if (/^\d+$/.test(this.subCategory.name)) {
        swal('اسم القسم الفرعي يجب ان يحتوي على حروف')
        $('#name').addClass('redborder')
        return 0
      }
      if (/^\d+$/.test(this.subCategory.name_ar)) {
        swal('اسم القسم الفرعي يجب ان يحتوي على حروف')
        $('#name_ar').addClass('redborder')
        return 0
      }
      formData.append('name', this.subCategory.name)
      formData.append('name_ar', this.subCategory.name_ar)
      formData.append('_method', 'PUT')
      if (this.subCategory.description) {
        formData.append('description', this.subCategory.description)
      }
      if (this.subCategory.description_ar) {
        formData.append('description_ar', this.subCategory.description_ar)
      }
      this.errors = await this.postRequest(formData, `${this.$hostUrl}sub-categories/${this.$route.params.id}`, '/sub-categories')
    },
    goBack () {
      this.categoriesOpened ? this.$router.go(-1) : this.$router.push({ path: '/sub-categories' })
    },
    validation () {
      const Allinput = document.querySelectorAll('form input')
      Allinput.forEach((input) => {
        // eslint-disable-next-line valid-typeof
        const select = input.hasAttribute('autocomplete')
        input.oninput = function () {
          input.classList.remove('redborder')
        }
        if (input.value === '' && input.type === 'text' && !select) {
          input.classList.add('redborder')
          swal(' لا يمكن ترك الحقل فارغا')
          return 0
        }
      })
    }
  }
}
</script>
<style>
.redborder{
  border-color:red !important
}
</style>
